import { connect } from 'react-redux';
import {
  requestHotels,
  requestSuggestedHotels,
  editHotel,
  requestHotelClaim,
  viewHotel,
  checkWaitlist,
  joinWaitlist,
} from '../modules/hotels';

import Hotels from '../components/Hotels';

const mapDispatchToProps = {
  requestHotels,
  requestSuggestedHotels,
  editHotel,
  requestHotelClaim,
  viewHotel,
  joinWaitlist,
  checkWaitlist,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.hotels.isFetching,
  needFetch: state.hotels.needFetch,
  hasError: state.hotels.hasError,
  hotels: state.hotels.hotels,
  suggested: state.hotels.suggested.hotels,
  suggestedNeedFetch: state.hotels.suggested.needFetch,
  suggestedisFetching: state.hotels.suggested.isFetching,
  onWaitlist: state.hotels.waitlist.onWaitlist,
  waitlistisFetching: state.hotels.waitlist.needFetch || state.hotels.waitlist.isFetching,
  perms: state.auth.perms,
  id: ownProps.params.id,
});

export default connect(mapStateToProps, mapDispatchToProps)(Hotels);



// WEBPACK FOOTER //
// src/routes/hotels/containers/HotelsContainer.js